import 'css-chunksrc/client/common/resourceAllocationMenu/styles.scss';export default {
  "resourceAllocationMenu": "_resourceAllocationMenu_dvw00_1",
  "search": "_search_dvw00_12"
};